import Request from '../helpers/request'
import RequestV2 from '../helpers/request-v2'
import Endpoints from '../config/endpoints'

export default class FileRequests {

    static save(fileDTO) {
        return Request.getInstance().createPostRequest(Endpoints.file.save, fileDTO)
    }

    static search(filter) {
        return RequestV2
            .getInstance()
            .createGetRequest(Endpoints.file.search, filter , null , false , true )
    }

}



// WEBPACK FOOTER //
// ./src/requests/file-requests.js